<template>
  <UApp :toaster="{ position: 'top-center' }">
    <Layout>
      <router-view />
    </Layout>
  </UApp>
</template>

<script setup>
import Layout from './layout/default.vue'
</script>
